export const ACTIONS_AI = {
	AI: 'ai_result_extraction',
} as const;
